import type { QueryClient } from "@tanstack/react-query";
import type { useDbClient } from "@tanstack/react-db";
import { myPlayersCollection } from "@/features/players/records";
import { accountProfileQueryOptions } from "../account.queries";

type RefreshResult =
  | { readonly kind: "refreshed" }
  | { readonly kind: "failed"; readonly message: string };

export async function refreshAccountResources({
  queryClient,
  dbClient,
  viewerId,
}: {
  readonly queryClient: QueryClient;
  readonly dbClient: ReturnType<typeof useDbClient>;
  readonly viewerId: string;
}): Promise<RefreshResult> {
  const profileOptions = accountProfileQueryOptions({ viewerId });
  const players = dbClient.collection(
    myPlayersCollection({ viewerId, elevatedPrivileges: false }),
  );
  await queryClient.cancelQueries({
    queryKey: profileOptions.queryKey,
    exact: true,
  });
  const results = await Promise.allSettled([
    queryClient.fetchQuery({ ...profileOptions, staleTime: 0 }),
    players.utils.refetch({ throwOnError: true }),
  ]);
  const failure = results.find((result) => result.status === "rejected");

  if (failure) {
    return {
      kind: "failed",
      message:
        failure.reason instanceof Error
          ? failure.reason.message
          : "Unable to refresh saved values.",
    };
  }

  return { kind: "refreshed" };
}
